import { render, staticRenderFns } from "./OrganizationListView.vue?vue&type=template&id=267a6560&"
import script from "./OrganizationListView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267a6560')) {
      api.createRecord('267a6560', component.options)
    } else {
      api.reload('267a6560', component.options)
    }
    module.hot.accept("./OrganizationListView.vue?vue&type=template&id=267a6560&", function () {
      api.rerender('267a6560', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/organization/OrganizationListView.vue"
export default component.exports